import { render } from "./NeoTopHolder.vue?vue&type=template&id=7ac3436a"
import script from "./NeoTopHolder.vue?vue&type=script&lang=js"
export * from "./NeoTopHolder.vue?vue&type=script&lang=js"

import "./NeoTopHolder.vue?vue&type=style&index=0&id=7ac3436a&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__